/**
 * Encode a data object to a Base64 string (URL-safe)
 * @param {Object} data
 * @returns {string}
 */
export function encodeData(data) {
  return btoa(
    Array.from(new TextEncoder().encode(JSON.stringify(data)), b =>
      String.fromCharCode(b)
    ).join('')
  );
}

/**
 * Decode a Base64 string back to a data object
 * @param {string} encoded
 * @returns {Object}
 */
export function decodeData(encoded) {
  if (!encoded) return {};
  try {
    const decoded = new TextDecoder().decode(
      Uint8Array.from(atob(encoded), c => c.charCodeAt(0))
    );
    return JSON.parse(decoded);
  } catch {
    return {};
  }
}
